import { useReportingStore } from "../../../../../stores/ReportingStore";
import LoaderStats from "../../LoaderStats";
import {
  ColorSwatch,
  Flex,
  Group,
  Paper,
  RingProgress,
  Stack,
  Text,
} from "@mantine/core";
import { BarChart } from "@mantine/charts";
import { useMemo } from "react";
import {
  getChartColors,
  sumDateStats,
} from "../../../../../functions/utilFunctions";
import ReportingInfo from "../../ReportingInfo";
import { useLanguage } from "../../../../../stores/LanguageStore";

const PerfDelivrabilityMulti = () => {
  const lang = useLanguage((s) => s.language);
  const progStats = useReportingStore((s) => s.progStats);

  const data = useMemo(() => {
    return progStats.map((item) => {
      let stats = sumDateStats(item.stats);
      const sent = stats.email_sent || 1;
      const delivered = stats.email_sent - stats.contact_email_bounce;

      const rate = (delivered / sent) * 100;

      return {
        prog: "",
        [item.prog.id]: Math.round(rate * 10) / 10,
      };
    });
  }, [progStats]);

  const averageRate = useMemo(() => {
    let total_sent = 0;
    let total_delivered = 0;

    progStats.forEach((item) => {
      let stats = sumDateStats(item.stats);
      total_sent += stats.email_sent;
      total_delivered += stats.email_sent - stats.contact_email_bounce;
    });

    if (total_sent) return (total_delivered / total_sent) * 100;
    return 0;
  }, [progStats]);

  const series = useMemo(() => {
    return progStats.map((item, index) => ({
      name: `${item.prog.id}`,
      label: `${item.prog.workflow_name}`,
      color: `${getChartColors()[index]}.5`,
    }));
  }, [progStats]);

  return (
    <Paper pos={"relative"} flex={1} p={"xl"} pt={"md"}>
      <LoaderStats isProgStats />

      <Group mb={32} justify="center">
        <Text size="lg" fw={600}>
          {lang.reports.perf_del_title}
        </Text>
      </Group>

      <BarChart
        h={200}
        w={"100%"}
        data={data}
        dataKey="prog"
        series={series}
        tickLine="y"
        maxBarWidth={64}
        barProps={{
          isAnimationActive: true,
          animationDuration: 600,
          radius: [8, 8, 0, 0],
        }}
        unit="%"
      />

      <Group mt={16} justify="space-between">
        <Stack gap={"xs"}>
          {progStats.map((item, index) => (
            <Group key={item.prog.id}>
              <ColorSwatch
                color={`var(--mantine-color-${getChartColors()[index]}-5)`}
                size={16}
              />
              <Text size="sm">
                {item.prog.workflow_name} #{item.prog.id}
              </Text>
            </Group>
          ))}
        </Stack>

        <Group justify="end" wrap="nowrap" ml={"auto"}>
          <ReportingInfo>
            <Text>{lang.reports.perf_del_average_text}</Text>
          </ReportingInfo>
          <Text size="lg">{lang.reports.perf_del_average}</Text>
          <RingProgress
            label={
              <Group justify="center" ml={16} mt={-8}>
                <Text size="lg" fw={600} ta="center">
                  {averageRate.toFixed(1)}%
                </Text>
              </Group>
            }
            roundCaps={averageRate < 92}
            sections={[{ value: averageRate, color: "green" }]}
          />
        </Group>
      </Group>
    </Paper>
  );
};

export default PerfDelivrabilityMulti;
